// extracted by mini-css-extract-plugin
export default {"feedbackBtn":"FeedbackBtn_feedbackBtn__FkzOv"};